// extracted by mini-css-extract-plugin
export var checkbox = "_8t-0";
export var circle = "_8t-3";
export var horizontalContainer = "_8t-7";
export var sm = "_8t-5";
export var switch0 = "_8t-2";
export var switchDisabled = "_8t-8";
export var switchEnabled = "_8t-1";
export var textSwitchContainer = "_8t-9";
export var textSwitchOption = "_8t-a";
export var textSwitchOptionSelected = "_8t-b";
export var verticalContainer = "_8t-6";
export var xs = "_8t-4";